import { format } from "date-fns";

export function utcToDate(utc) {
	const d = new Date(utc ?? 0);
	return format(d, "dd.MM.yyyy");
}

export function utcToLocalDateTime(utc) {
	const d = new Date(utc ?? 0);
	return format(d, "dd.MM.yyyy HH:mm");
}
